module.exports = __webpack_public_path__ + "img/DealerIcons-EV-On.0f5fcc0.jpg";